<!--
 * @Author: Czy
 * @Date: 2021-08-23 14:04:19
 * @LastEditTime: 2021-08-23 15:29:36
 * @FilePath: /plant-protection-association/src/components/headerTitle.vue
 *  
-->
<template >
  <div class="exhibition-all">
    <div class="exhibition-line">
      <div
        class="exhibition-line-left"
        :style="{ 'background-color': lineColor }"
      ></div>
      <div
        class="exhibition-line-right"
        :style="{ 'background-color': spotColor }"
      ></div>
    </div>

    <!-- 展会动态标题 -->
    <div class="exhibition-title">
      <span class="exhibition-title-text1" :style="{ color: titleColor }">{{
        title
      }}</span>

      <span class="exhibition-title-text2" :style="{ color: EntitleColor }">{{
        Entitle
      }}</span>
      <span class="exhibition-title-text3" :style="{ color: titleColor }">{{
        ranking
      }}</span>
    </div>

    <div class="exhibition-line">
      <div
        class="exhibition-line-right"
        :style="{ 'background-color': spotColor }"
      ></div>
      <div
        class="exhibition-line-left"
        :style="{ 'background-color': lineColor }"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "标题",
    },
    Entitle: {
      type: String,
      default: "title",
    },
    titleColor: {
      type: String,
      default: "#0080c9",
    },
    EntitleColor: {
      type: String,
      default: "#333",
    },
    lineColor: {
      type: String,
      default: "#333",
    },
    spotColor: {
      type: String,
      default: "#0080c9",
    },
    ranking:{
      type:String,
      default:''
    }
  },
};
</script>
<style lang="scss" scoped>
/* 展会动态电脑端 */
.exhibition-all {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 70%;
  margin-left: 15%;
  .exhibition-line {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 30%;
    .exhibition-line-left {
      width: 90%;
      height: 1px;
      background-color: #000;
      display: flex;
      flex-direction: row;
      align-items: center;
      // position: relative;
      // &:before {
      //     content:" ";
      //     background-color:#0080c9;
      //     height:5px;
      //     width:20px;
      //     position:absolute;
      //     right:0px;

      // }
    }
    .exhibition-line-right {
      width: 10%;
      height: 5px;
      background-color: #0080c9;
    }
  }
}

.exhibition-title {
  margin: 20px 20px;
  display: flex;
  min-width: 100px;
  //   background-color: red;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 15px;
}
.exhibition-title-text1 {
  color: #0080c9;
  font-size: 20px;
}
.exhibition-title-text2 {
  // color: #0080c9;
  font-size: 12px;
  font-weight: 400;
}
.exhibition-title-text3 {
  font-size: 12px;
  font-weight: 400;
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderTitle.vue